module.exports = __webpack_public_path__ + "img/59ddaf2.png";